export default {"src":"/_next/static/media/valet.696a5539.svg","height":40,"width":42,"blurWidth":0,"blurHeight":0};